// Copy for the debit note document. It follows the pure-agent reimbursement
// format (Rule 33, CGST Rules 2017) of the India debit note template: Nook Pay pays
// publisher invoices raised on the brand, then claims the exact amount back
// from the brand with no GST of its own on top.

export const DEBIT_NOTE_AGREEMENT_NAME = "Referral Marketing Services Agreement";

// Used when the note itself carries no due date.
export const DEBIT_NOTE_PAYMENT_TERMS = "30 days";

export const DEBIT_NOTE_SUPPORTING_DOCUMENTS = [
    "Copies of vendor invoices (issued to the brand)",
    "Bank statements / payment proofs for vendor payouts",
    "TDS certificates (if applicable)",
    "Payout authorization from the brand",
    "Reconciliation statement"
];

/**
 * Terms and conditions, in order. Each is a function of the parties so the
 * brand's name reads in place of the template's placeholder.
 * @param issuer the Nook Pay entity's name
 * @param brand the brand's name
 * @param netAmount formatted net amount claimed
 * @param paymentTerms e.g. "30 days" or "by 12 Oct 2026"
 */
export const getDebitNoteTerms = ({ issuer, brand, netAmount, paymentTerms }) => [
    {
        title: "Pure Agent Capacity",
        body : `${issuer} has facilitated these vendor payouts as pure agent of ${brand}, as per the terms of the ${DEBIT_NOTE_AGREEMENT_NAME}.`
    },
    {
        title: "No ITC Claimed",
        body : `${issuer} has not claimed Input Tax Credit (ITC) on any of the GST charged in the above vendor invoices. ITC eligibility rests with ${brand} as the recipient of the underlying services.`
    },
    {
        title: "No Margin / Value Addition",
        body : `The amounts shown above represent the exact amounts paid to vendors on behalf of ${brand}, without any markup, processing fee, or hidden charges. Any service charges / commission by ${issuer} for referral and marketing services are billed separately under the main Tax Invoice.`
    },
    {
        title: "Vendor Invoices on Brand",
        body : `All vendor invoices mentioned above have been raised in the name of ${brand} with ${brand}'s GSTIN. Copies of such invoices are attached / available on request.`
    },
    {
        title: "Payment Proof",
        body : `${issuer} will provide proof of payments made to vendors (bank statements, UTRs, payment confirmations) in support of the amounts claimed in this Debit Note.`
    },
    {
        title: "TDS Compliance",
        body : `TDS, if any, has been deducted by ${brand} as per Income-tax Act provisions and is reflected in the summary above. ${issuer} will not claim any further deduction.`
    },
    {
        title: "Reimbursement Request",
        body : `${issuer} hereby requests reimbursement from ${brand} of the net amount shown above (${netAmount}) within ${paymentTerms} of receipt of this Debit Note.`
    },
    {
        title: "No GST on Reimbursement",
        body : `As per Rule 33 of the CGST Rules, 2017, these vendor payout reimbursements are excluded from the taxable value of ${issuer}'s supply and no GST is charged by ${issuer}.`
    },
    {
        title: "Reconciliation",
        body : `This Debit Note is part of the monthly / periodic settlement between ${issuer} and ${brand} for the referral marketing services and payout facilitation services rendered.`
    }
];
